import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface ChatWindowConfigState {
  cs_chatWindowConfig: {
    isClosed: boolean;
    isMinimized: boolean;
  };
}

const initialState: ChatWindowConfigState = {
  cs_chatWindowConfig: {
    isClosed: true,
    isMinimized: false,
  },
};

export const chatWindowConfigSlice = createSlice({
  name: "cs_chatWindowConfig",
  initialState,
  reducers: {
    // Generic update action (kept for backward compatibility)
    updateChatWindowConfig: (
      state,
      action: PayloadAction<Partial<ChatWindowConfigState["cs_chatWindowConfig"]>>
    ) => {
      state.cs_chatWindowConfig = {
        ...state.cs_chatWindowConfig,
        ...action.payload,
      };
    },
    // Specific action creators for better type safety and clarity
    openChat: (state) => {
      state.cs_chatWindowConfig.isClosed = false;
      state.cs_chatWindowConfig.isMinimized = false;
    },
    closeChat: (state) => {
      state.cs_chatWindowConfig.isClosed = true;
      state.cs_chatWindowConfig.isMinimized = false;
    },
    minimizeChat: (state) => {
      state.cs_chatWindowConfig.isMinimized = true;
      // Don't close when minimizing
    },
    restoreChat: (state) => {
      state.cs_chatWindowConfig.isMinimized = false;
      state.cs_chatWindowConfig.isClosed = false;
    },
    toggleMinimize: (state) => {
      state.cs_chatWindowConfig.isMinimized = !state.cs_chatWindowConfig.isMinimized;
    },
  },
});

export const {
  updateChatWindowConfig,
  openChat,
  closeChat,
  minimizeChat,
  restoreChat,
  toggleMinimize,
} = chatWindowConfigSlice.actions;

export default chatWindowConfigSlice.reducer;
